<template>
    <div>
        <Teleport to="#topMiddle">
            <CurrentUser />
        </Teleport>

        <router-view></router-view>
    </div>
</template>

<script>
import CurrentUser from '@/app/components/CurrentUser';

export default {
    components: {
        CurrentUser,
    },
};
</script>
